import {
  Box,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from "@chakra-ui/react";
import { Col, Row } from "antd";
import { DiaSemanaNumero } from "core/features/area-comum/typings";
import { BloqueioAntesDepoisReservaItem } from "core/features/area-comum/typings/index";
import colors from "core/resources/theme/colors";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import SelectIntervaloPeriodo from "ui/components/Input/SelectIntervaloPeriodo";
import { RegraReservaComponentProps } from "..";
import RangeSliderThumbLegend from "./RangeSliderThumbLegend";
import { Flex } from "@chakra-ui/layout";
import OutlineButton from "ui/components/Button/OutlineButton";
import { showConfirm } from "infra/helpers/alerta";

function BloqueioPeriodoAntesDepoisReservaItem({
  control,
  getNameLabel,
  onSaveRegra,
  item,
  index,
  onExcluirBloqueio,
}: RegraReservaComponentProps & {
  item: BloqueioAntesDepoisReservaItem;
  index: number;
  onExcluirBloqueio?: () => any;
}) {
  const getTitleNameLabel = (dia: DiaSemanaNumero) => {
    const map = {
      [DiaSemanaNumero.Domingo]: "Domingo",
      [DiaSemanaNumero.Segunda]: "Segunda-feira",
      [DiaSemanaNumero.Terca]: "Terça-feira",
      [DiaSemanaNumero.Quarta]: "Quarta-feira",
      [DiaSemanaNumero.Quinta]: "Quinta-feira",
      [DiaSemanaNumero.Sexta]: "Sexta-feira",
      [DiaSemanaNumero.Sabado]: "Sábado",
    };
    return map[dia];
  };

  const {
    diaSemana,
    periodoAntes,
    periodoDepois,
    tipoIntervaloPeriodoAntes,
    tipoIntervaloPeriodoDepois,
  } = item;

  const showSlider =
    (tipoIntervaloPeriodoAntes && Number.isInteger(periodoAntes)) ||
    (tipoIntervaloPeriodoDepois && Number.isInteger(periodoDepois));

  const labelDiaSemana = Number.isInteger(diaSemana)
    ? getTitleNameLabel(diaSemana!)
    : null;

  const getSliderValue = () => {
    if (Number.isInteger(periodoAntes) && Number.isInteger(periodoDepois)) {
      return [30, 50, 70];
    } else if (Number.isInteger(periodoAntes)) {
      return [30, 50, 50];
    } else if (Number.isInteger(periodoDepois)) {
      return [50, 50, 70];
    }

    return [50, 50, 50];
  };

  const onExcluir = () => {
    showConfirm().then(({ isConfirmed }) => {
      if (isConfirmed) {
        onExcluirBloqueio?.();
      }
    });
  };

  const onSave = () => {
    onSaveRegra?.({
      bloqueioAntesDepoisReserva: item,
    });
  };

  return (
    <Box>
      {labelDiaSemana ? (
        <Flex alignItems="center" mb={4}>
          <Text fontWeight="medium" fontSize={18} alignSelf="center">
            {labelDiaSemana}
          </Text>

          {item.diaSemana !== null ? (
            <OutlineButton
              ml={4}
              onClick={() => {
                onSave();
              }}
            >
              Salvar
            </OutlineButton>
          ) : null}

          {onExcluirBloqueio ? (
            <OutlineButton
              onClick={onExcluir}
              ml={4}
              color={colors.red}
              lineColor={colors.red}
            >
              Remover
            </OutlineButton>
          ) : null}
        </Flex>
      ) : null}
      <Row gutter={32}>
        <Col sm={10}>
          <Text mb="16px" fontWeight="medium">
            Tempo antes da reserva
          </Text>
          <Row gutter={32}>
            <Col sm={14}>
              <Field
                control={control}
                label="Formato de tempo"
                name={`bloqueioAntesDepoisReserva.${index}.tipoIntervaloPeriodoAntes`}
                render={({ field, isInvalid }) => (
                  <SelectIntervaloPeriodo
                    value={field.value}
                    defaultValue={null}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    isInvalid={isInvalid}
                    getPopupContainer={() => document.body}
                    allowClear
                  />
                )}
              />
            </Col>

            {tipoIntervaloPeriodoAntes ? (
              <Col sm={10}>
                <Field
                  control={control}
                  label={getNameLabel(tipoIntervaloPeriodoAntes)}
                  rules={{
                    required: true,
                  }}
                  shouldUnregister
                  name={`bloqueioAntesDepoisReserva.${index}.periodoAntes`}
                  render={({ field, isInvalid }) => (
                    <InputMoney
                      isInvalid={isInvalid}
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="0"
                      step={1}
                      decimalScale={0}
                      decimalsLimit={0}
                    />
                  )}
                />
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col sm={10}>
          <Text mb="16px" fontWeight="medium">
            Tempo depois da reserva
          </Text>
          <Row gutter={32}>
            <Col sm={14}>
              <Field
                control={control}
                label="Formato de tempo"
                name={`bloqueioAntesDepoisReserva.${index}.tipoIntervaloPeriodoDepois`}
                render={({ field, isInvalid }) => (
                  <SelectIntervaloPeriodo
                    value={field.value}
                    defaultValue={null}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    isInvalid={isInvalid}
                    getPopupContainer={() => document.body}
                    allowClear
                  />
                )}
              />
            </Col>

            {tipoIntervaloPeriodoDepois ? (
              <Col sm={10}>
                <Field
                  control={control}
                  label={getNameLabel(tipoIntervaloPeriodoDepois!)}
                  rules={{
                    required: true,
                  }}
                  shouldUnregister
                  name={`bloqueioAntesDepoisReserva.${index}.periodoDepois`}
                  render={({ field, isInvalid }) => (
                    <InputMoney
                      isInvalid={isInvalid}
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="0"
                      step={1}
                      decimalScale={0}
                      decimalsLimit={0}
                    />
                  )}
                />
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>
      {showSlider ? (
        <Box mt={8}>
          <RangeSlider
            colorScheme="red"
            value={getSliderValue()}
            cursor="default"
            pointerEvents="none"
          >
            <RangeSliderTrack bg={colors.primaryBlue40} h={1.5}>
              <RangeSliderFilledTrack />
            </RangeSliderTrack>
            <RangeSliderThumb
              index={0}
              opacity={
                Number.isInteger(periodoAntes) && tipoIntervaloPeriodoAntes
                  ? 1
                  : 0
              }
            >
              {tipoIntervaloPeriodoAntes ? (
                <RangeSliderThumbLegend
                  text={`${periodoAntes} ${getNameLabel(
                    tipoIntervaloPeriodoAntes
                  )} antes`}
                />
              ) : null}
            </RangeSliderThumb>

            <RangeSliderThumb
              bg={colors.primary}
              w="3px"
              h="25px"
              rounded={0}
              index={1}
              aria-label="Dia da reserva"
            >
              <Box fontWeight="medium" mt="60px">
                Dia da Reserva
              </Box>
            </RangeSliderThumb>

            <RangeSliderThumb
              index={2}
              opacity={
                Number.isInteger(periodoDepois) && tipoIntervaloPeriodoDepois
                  ? 1
                  : 0
              }
            >
              {tipoIntervaloPeriodoDepois ? (
                <RangeSliderThumbLegend
                  text={`${periodoDepois} ${getNameLabel(
                    tipoIntervaloPeriodoDepois
                  )} depois`}
                />
              ) : null}
            </RangeSliderThumb>
          </RangeSlider>
        </Box>
      ) : null}
    </Box>
  );
}

export default BloqueioPeriodoAntesDepoisReservaItem;
